import { Menu } from 'devextreme-react';
import { Component } from 'react';
import { apiGetP } from '../../GanjiTools';
import MenuBuilder from '../ka-layout/MenuBuilder';
import CommandManager from '../CommandManager';

class WtMenu extends Component {
    state = {
        items: [],
    }

    loadItemsP = name => new Promise((resolve, reject) => {
        // if (!(name?.length > 0)) {
        //     reject?.('Menu name is undefined.');
        //     return;
        // }

        name ??= '';

        apiGetP(`/api/menu/load?name=${name}`)
            .catch(reject)
            .then(res => {
                res ??= { error: 'No response' };

                if (res.error?.length > 0) {
                    reject?.(res.error);
                    return;
                }

                let items = MenuBuilder.filterItems(res.items ?? [], i => i.iid > 0);

                MenuBuilder.doOnAllItems(items, item => {
                    item.onClick = () => CommandManager.processP(item)
                        .catch(window.notif)
                        .then(compo => {
                            if (compo)
                                this.props.onComponentResult?.(compo);
                        });
                });

                resolve?.(items);
            });
    });

    componentDidMount() {
        this.loadItemsP(this.props.name)
            .catch(err => this.setState({ error: 'Error! ' + err }))
            .then(items => this.setState({ items, error: '' }));
    }

    render() {
        if (this.state.error?.length > 0)
            return (<div>{this.state.error}</div>);

        if (!(this.state.items?.length > 0))
            this.state.items = [{ text: 'گزینه ای وجود ندارد', icon: 'warning', disabled: true }];

        return (
            <Menu items={this.state.items} rtlEnabled showSubmenuMode='onHover'
                key={'top' + this.state.itemsKey}
            />
        );
    }
}

export default WtMenu;